import { createSlice } from '@reduxjs/toolkit';

const getUserAddressSlice = createSlice({
  name: 'getUserAddress',
  initialState: {
    loading: false,
    addressData: null,
    error: null,
    success: false
  },
  reducers: {
    getUserAddressRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getUserAddressSuccess(state, action) {
      state.loading = false;
      state.addressData = action.payload;
      state.success = true;
    },
    getUserAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    getUserAddressReset(state) {
      state.loading = false;
      state.error = null;
      state.addressData = null;
      state.success = false;
    }
  },
});

export const {
  getUserAddressRequest,
  getUserAddressSuccess,
  getUserAddressFailure,
  getUserAddressReset
} = getUserAddressSlice.actions;

export default getUserAddressSlice.reducer;
